import { PhoneNumber, parsePhoneNumberFromString } from "libphonenumber-js";
import { useMemo } from "react";
import * as yup from "yup";

const nameRegex = /^[a-zA-Z\s-'.]*$/;
const whitespaceRegex = /^(?! ).*[^ ]$/;

export const useDynamicEmployeeValidationSchema = () => {
  return useMemo(() => {
    const phoneNumberValidation = yup
      .string()
      .required()
      .test(
        "is-valid-mobile-phone",
        `Invalid mobile phone number - please include country code eg. +64`,
        function (value) {
          try {
            const phoneNumber: PhoneNumber | undefined =
              parsePhoneNumberFromString(value);
            if (!phoneNumber) {
              return false;
            }

            return phoneNumber.isValid();
          } catch (error) {
            return this.createError({
              message: `Invalid mobile phone number - please include country code eg. +64`
            });
          }
        }
      );

    const emailValidation = yup
      .string()
      .email("Invalid email")
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email format")
      .test(
        "not-invalid",
        "Email cannot contain special characters in invalid positions",
        (value) => !/^\S+\*|\S+@-/.test(value ?? "")
      )
      .required("Email is required");

    return yup.object().shape({
      firstName: yup
        .string()
        .max(100)
        .required()
        .matches(nameRegex, "Invalid characters in first name")
        .matches(
          whitespaceRegex,
          "First name cannot start or end with a space"
        ),
      lastName: yup
        .string()
        .max(100)
        .required()
        .matches(nameRegex, "Invalid characters in last name")
        .matches(whitespaceRegex, "Last name cannot start or end with a space"),

      phone: phoneNumberValidation,
      email: emailValidation
    });
  }, []);
};
